import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ClickOutside from 'vue-click-outside';

library.add(faQuestionCircle);

export default {
  name: 'hint',
  props: {
    position: {
      type: String,
      required: false,
      default: 'above'
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    hide() {
      this.isActive = false;
    }
  },

  directives: {
    ClickOutside
  },

  components: {
    FontAwesomeIcon
  }
};
